<script lang="ts" setup>
import MediaList from '@/components/media/MediaList.vue';
import { Hero } from '@/models/hero.model';
import { ref, PropType, watch } from 'vue';

const props = defineProps({
  modelValue: { type: Object as PropType<Hero>, required: true },
});
const value = ref<Hero>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue']);

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);
</script>
<template>
  <v-row>
    <v-col>
      <v-text-field
        v-model="value.name"
        @change="update"
        label="Name"
        required
      ></v-text-field>
      <MediaList v-model="value" @change="update" />
    </v-col>
  </v-row>
</template>
